import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../ReducerRegister";
import DetailsService from "../../../../services/screens/admin/oralbook/DetailsService";
import { ActionTypes } from "../../../actionTypes/screens/admin/oralbook/DetailsActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.oralbook.details;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            DetailsService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),


    loadUnitsAsync: (partnerId, id, sectionIndex) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_UNITS_ASYNC, partnerId, id, sectionIndex });

            DetailsService.loadUnits(
                { partnerId, id },
                response => {
                    dispatch(Actions.loadUnitsSuccess(response, id, sectionIndex));
                },
                error => {
                    dispatch(Actions.loadUnitsFailure(error));
                }
            );
        };
    },

    loadUnitsSuccess: (data, id, sectionIndex) => ({
        type: ActionTypes.LOAD_UNITS_SUCCESS,
        parentType: ActionTypes.LOAD_UNITS_ASYNC,
        postReducer: loadUnitsSuccessPostReducer,
        data,
        id,
        sectionIndex
    }),

    loadUnitsFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_UNITS_ASYNC,
        error
    }),

    deleteSectionsAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_SECTIONS_ASYNC, vo });

            DetailsService.deleteSections(
                { selectedItems: Array.from(vo.selectedSections), partnerId: vo.partnerId },
                response => {
                    dispatch(Actions.deleteSectionsSuccess(response, vo.selectedSections));
                },
                error => {
                    dispatch(Actions.deleteSectionsFailure(error));
                }
            );
        };
    },

    deleteSectionsSuccess: (data, selectedItems) => ({
        type: ActionTypes.DELETE_SECTIONS_SUCCESS,
        parentType: ActionTypes.DELETE_SECTIONS_ASYNC,
        postReducer: deleteSectionsSuccessPostReducer,
        data,
        selectedItems
    }),

    deleteSectionsFailure: error => ({
        type: ActionTypes.DELETE_SECTIONS_FAILURE,
        parentType: ActionTypes.DELETE_SECTIONS_ASYNC,
        error
    }),

    deleteUnitsAsync: selectedItems => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_UNITS_ASYNC, selectedItems });

            DetailsService.deleteUnits(
                { selectedItems: Array.from(selectedItems) },
                response => {
                    dispatch(Actions.deleteUnitsSuccess(response, selectedItems));
                },
                error => {
                    dispatch(Actions.deleteUnitsFailure(error));
                }
            );
        };
    },

    deleteUnitsSuccess: (data, selectedItems) => ({
        type: ActionTypes.DELETE_UNITS_SUCCESS,
        parentType: ActionTypes.DELETE_UNITS_ASYNC,
        postReducer: deleteUnitsSuccessPostReducer,
        data,
        selectedItems
    }),

    deleteUnitsFailure: error => ({
        type: ActionTypes.DELETE_UNITS_FAILURE,
        parentType: ActionTypes.DELETE_UNITS_ASYNC,
        error
    }),

    reorderSectionsAsync: (destIndex, sourceIndex) => {
        return (dispatch, getState) => {

            const { courseDetails } = getState().screens[reducer.key];
            const { sections } = courseDetails;
            let direction = (sourceIndex < destIndex) ? 1 : -1;
            let nextIndex = destIndex + direction;
            const destId = sections[destIndex].id;
            const nextId = (nextIndex >= 0 && nextIndex < sections.length) ? sections[nextIndex].id : null;
            const sourceId = sections[sourceIndex].id;

            dispatch({
                type: ActionTypes.REORDER_SECTIONS_ASYNC,
                postReducer: reorderSectionAsyncPostReducer,
                destIndex, sourceIndex
            });

            DetailsService.reorderSections(
                { courseId: courseDetails.id, destId, nextId, sourceId, direction },
                response => {
                    dispatch(Actions.reorderSectionSuccess(response));
                },
                error => {
                    dispatch(Actions.reorderSectionFailure(error));
                }
            );
        };
    },

    reorderSectionSuccess: (data) => ({
        type: ActionTypes.REORDER_SECTIONS_SUCCESS,
        parentType: ActionTypes.REORDER_SECTIONS_ASYNC,
        data
    }),

    reorderSectionFailure: error => ({
        type: ActionTypes.REORDER_SECTIONS_FAILURE,
        parentType: ActionTypes.REORDER_SECTIONS_ASYNC,
        error
    }),

    reorderUnitsAsync: (destIndex, sourceIndex) => {
        return (dispatch, getState) => {

            const { units, currentSection } = getState().screens[reducer.key];
            let direction = (sourceIndex < destIndex) ? 1 : -1;
            let nextIndex = destIndex + direction;
            const destId = units[destIndex].id;
            const nextId = (nextIndex >= 0 && nextIndex < units.length) ? units[nextIndex].id : null;
            const sourceId = units[sourceIndex].id;

            dispatch({
                type: ActionTypes.REORDER_UNITS_ASYNC,
                postReducer: reorderUnitAsyncPostReducer,
                destIndex, sourceIndex
            });

            DetailsService.reorderUnits(
                { sectionId: currentSection, destId, nextId, sourceId, direction },
                response => {
                    dispatch(Actions.reorderUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.reorderUnitFailure(error));
                }
            );
        };
    },

    reorderUnitSuccess: (data) => ({
        type: ActionTypes.REORDER_UNITS_SUCCESS,
        parentType: ActionTypes.REORDER_UNITS_ASYNC,
        data
    }),

    reorderUnitFailure: error => ({
        type: ActionTypes.REORDER_UNITS_FAILURE,
        parentType: ActionTypes.REORDER_UNITS_ASYNC,
        error
    }),

    setCurrentSection: id => ({
        type: ActionTypes.SET_CURRENT_SECTION,
        id
    }),

    selectSection: id => ({
        type: ActionTypes.SELECT_SECTION,
        id
    }),

    selectUnit: (id,isChecked) => ({
        type: ActionTypes.SELECT_UNIT,
        id,
        isChecked
    }),

}
//
// Initial State
//
const INITIAL_STATE = {
    courseDetails: null,
    currentSection: null,
    readOnly: false,
    units: null,
    selectedSections: new Set(),
    selectedUnits: new Set(),
    sectionId: null,
    sectionIndex: null, 
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { courseDetails, readOnly } = data;

    return { ...state, courseDetails, readOnly };
};

const loadUnitsSuccessPostReducer = (state, { data, id, sectionIndex }) => {
    const { units } = data;
    return { ...state, units, sectionId: id, sectionIndex };
}

const deleteSectionsSuccessPostReducer = (state, { data, selectedItems }) => {
    let sections = [];

    Array.from(state.courseDetails.sections).forEach(section => {
        if (!selectedItems.has(section.id)) {
            sections.push(section)
        }
    })

    let { currentSection, units } = state;
    if (selectedItems.has(currentSection)) {
        currentSection = null;
        units = null;
    }

    return {
        ...state, selectedSections: new Set(), courseDetails: { ...state.courseDetails, sections }, currentSection, units
    };
}

const deleteUnitsSuccessPostReducer = (state, { selectedItems }) => {
    let units = [];


    Array.from(state.units).forEach(unit => {
        if (!selectedItems.has(unit.id)) {
            units.push(unit)
        }
    })

    return { ...state, selectedUnits: new Set(), units };
}

const reorderSectionAsyncPostReducer = (state, { destIndex, sourceIndex }) => {
    const sections = Array.from(state.courseDetails.sections);
    const [removed] = sections.splice(sourceIndex, 1);
    sections.splice(destIndex, 0, removed);
    return { ...state, courseDetails: { ...state.courseDetails, sections } };
};

const reorderUnitAsyncPostReducer = (state, { destIndex, sourceIndex }) => {
    const units = Array.from(state.units)
    const [removed] = units.splice(sourceIndex, 1);
    units.splice(destIndex, 0, removed);
    return { ...state, units };
};

const setCurrentSectionReducer = (state, { id }) => {
    return { ...state, currentSection: id };
};

const selectSectionReducer = (state, { id }) => {

    let selectedSections = new Set(state.selectedSections);
    if (selectedSections.has(id)) {
        selectedSections.delete(id);
    } else {
        selectedSections.add(id);
    }

    return { ...state, selectedSections };
};


const selectUnitReducer = (state, { id, isChecked }) => {
    let selectedUnits = new Set(state.selectedUnits);
    const units = Array.from(state.units);

    if (!id) {
        if (!isChecked) {
            selectedUnits = new Set();
        }
        else {
            selectedUnits = new Set(units.map(u => u.id));
        }
    } else {
        if (selectedUnits.has(id)) {
            selectedUnits.delete(id);
        } else {
            selectedUnits.add(id);
        }
    }

    return { ...state, selectedUnits };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_UNITS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_UNITS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_UNITS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_SECTIONS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_SECTIONS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_SECTIONS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REORDER_SECTIONS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REORDER_SECTIONS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REORDER_SECTIONS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_UNITS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_UNITS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_UNITS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REORDER_UNITS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REORDER_UNITS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REORDER_UNITS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SET_CURRENT_SECTION]: setCurrentSectionReducer,
    [ActionTypes.SELECT_SECTION]: selectSectionReducer,
    [ActionTypes.SELECT_UNIT]: selectUnitReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
